export const COUNTRY_CODE_US = "US";

export const COUNTRY_US_REGIONS = [
  "AK",
  "AL",
  "AR",
  "AS",
  "AZ",
  "CA",
  "CO",
  "CT",
  "DC",
  "DE",
  "FL",
  "GA",
  "GU",
  "HI",
  "IA",
  "ID",
  "IL",
  "IN",
  "KS",
  "KY",
  "LA",
  "MA",
  "MD",
  "ME",
  "MI",
  "MN",
  "MO",
  "MS",
  "MT",
  "NC",
  "ND",
  "NE",
  "NH",
  "NJ",
  "NM",
  "NV",
  "NY",
  "OH",
  "OK",
  "OR",
  "PA",
  "PR",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VA",
  "VI",
  "VT",
  "WA",
  "WI",
  "WV",
  "WY",
];

export const ACCESS_TOKEN_COOKIE = "PSAccess";

/** Post-accept redirect target set before sending users to `/updated-terms`. */
export const TERMS_UPDATE_REDIRECT_COOKIE = "turls";

export const REFRESH_TOKEN_COOKIE = "PSRefresh";

export const PS_STATE_COOKIE = "PSState";

export const SSO_ID_COOKIE = "PSUser";

export const ATTR_URL_COOKIE = "PSAttrUrl";

export const ATTR_REFERRER_COOKIE = "PSAttrReferrer";

export const FORTER_TOKEN_COOKIE = "forterToken";

export const PROMO_EXTERNAL_ID_COOKIE = "promo";

export const PROMO_ID_COOKIE = "promo-id";

export const PREFERRED_LOCALE_COOKIE = "preferred_locale";

export const INITIAL_LOCALE_COOKIE = "initial_locale";

export const GOOGLE_USER_COOKIE = "ps_g_user";

export const PSSK_COOKIE = "PSSK";

export const PSSKT_COOKIE = "PSSKT";

export const PSSUT_COOKIE = "PSUT";

export const PSMETRO_COOKIE = "PSmetro";

export const SEARCH_ID_COOKIE = "search_id";

/**
 * Legacy consent cookie, shared across Peerspace apps on the registrable domain and written
 * by `@segment/consent-manager`, which this app no longer loads. Read only so a choice made
 * on a not-yet-migrated app still counts; delete once every app runs OneTrust.
 */
export const TRACKING_PREFERENCES_COOKIE = "tracking-preferences";

export const PAY_AT_VENUE_WITH_DEPOSIT = "PAY_AT_VENUE_WITH_DEPOSIT";

export const PAY_IN_FULL = "PAY_IN_FULL";

/** Listing `pay_at_venue.type` when minimum spend is collected as a deposit at checkout. */
export const LISTING_PAY_AT_VENUE_TYPE_MINIMUM_SPEND_DEPOSIT =
  "minimum_spend_deposit";
